import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import LoginForm from 'components/forms/login-form';
import { AppToaster } from 'components/AppToaster';
import { Intent } from '@blueprintjs/core';
import { shibLogin, fetchAppUser, logout } from 'actions/users';
import { resetPassword, changePassword, login } from 'api/users';
import { validateCaptcha } from 'api/utils';
import CaptchaKeys from '../utils/captcha';

class Login extends Component {
  state = {
    username: '',
    password: '',
    isSubmitting: false,
    isForgot: false,
    isChanging:
      this.props.appUser &&
      !this.props.appUser.ssoUser &&
      this.props.appUser.passwordReset === 1,
    oldPassword: '',
    newPassword: '',
    checkPassword: '',
    captchaPass: false,
    showCaptchaError: false,
    error: false,
  };

  componentDidUpdate() {
		sessionStorage.removeItem('vr_params'); // clean out our sticky assessment search when someone goes to the login page
    if (!this.props.isFetching && this.state.isSubmitting) {
      this.setState({ isSubmitting: false });
    }
  }
  handleChange = e => {
    const target = e.target;
    const name = target.name;
    const value = target.value;

    this.setState({ [name]: value, error: false });
  };
  handleReCaptchaChange = value => {
    this.setState({ isSubmitting: true, showCaptchaError: false });
    validateCaptcha(value)
      .then(res => {
        this.setState({ isSubmitting: false });
        res.data.success
          ? this.setState({ captchaPass: true })
          : this.setState({ showCaptchaError: true });
      })
      .catch(err => {
        this.setState({ showCaptchaError: true });
      });
  };
  handleSubmit = () => {
    if (this.state.captchaPass || process.env.REACT_APP_IGNORE_CAPTCHA === "true") {
      this.setState({ isSubmitting: true });
      login(this.state.username, this.state.password)
        .then(res => this.props.fetchAppUser(res.data.token))
        .catch(err => this.setState({ error: true }));
    }
  };

  handleShibSubmit = () => {
    this.props.shibLogin();
  };

  handleKeyDown = e => {
    if (e.keyCode === 13 && !this.state.isForgot && !this.state.isSubmitting) {
      this.handleSubmit();
    }
  };
  handleForgot = () => {
    this.setState({ isForgot: true });
  };
  handleCancel = () => {
    this.setState({ isForgot: false });
  };
  handleReset = () => {
    this.setState({ isSubmitting: true });
    resetPassword(this.state.username)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.setState({ isSubmitting: false, isForgot: false });
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };
  handleChangePassword = () => {
    if (this.state.newPassword !== this.state.checkPassword) {
      AppToaster.show({
        message: 'Passwords must match',
        intent: Intent.DANGER,
      });
      return;
    }

    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        this.state.newPassword
      )
    ) {
      AppToaster.show({
        message:
          'Password must be a minimum eight characters and contain at least one uppercase letter, one lowercase letter, one number and one special character',
        intent: Intent.DANGER,
      });
      return;
    }

    this.setState({ isSubmitting: true });
    changePassword(
      this.props.appUser.userID,
      this.state.oldPassword,
      this.state.newPassword
    )
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.setState({ isSubmitting: false, isChanging: false });
        this.props.logout();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };
  render() {
    return (
      <Container>
        <LoginForm
          handleSubmit={this.handleSubmit}
          handleShibSubmit={this.handleShibSubmit}
          handleKeyDown={this.handleKeyDown}
          handleForgot={this.handleForgot}
          handleChangePassword={this.handleChangePassword}
          handleCancel={this.handleCancel}
          handleReset={this.handleReset}
          isForgot={this.state.isForgot}
          isChanging={this.state.isChanging}
          username={this.state.username}
          password={this.state.password}
          oldPassword={this.state.oldPassword}
          newPassword={this.state.newPassword}
          checkPassword={this.state.checkPassword}
          handleChange={this.handleChange}
          handleReCaptchaChange={this.handleReCaptchaChange}
          sitekey={CaptchaKeys.GOOGLE_RECAPTCHA_SITE_KEY} //Change Captcha in utils/captcha.js
          isFetching={this.props.isFetching}
          isSubmitting={this.state.isSubmitting}
          captchaPass={this.state.captchaPass}
          errors={{
            message: 'Invalid username or password',
            isError: this.state.error,
          }}
          captchaErrors={{
            message: 'There was an issue validating the CAPTCHA.',
            isError: this.state.showCaptchaError,
          }}
        />
      </Container>
    );
  }
}
const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(16, 92, 127, 0.77);
  background: -moz-linear-gradient(
    -45deg,
    rgba(16, 92, 127, 0.77) 0%,
    rgba(16, 92, 127, 0.79) 7%,
    rgba(40, 160, 220, 0.88) 47%,
    rgba(28, 161, 222, 0.95) 80%,
    rgba(26, 172, 240, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(16, 92, 127, 0.77)),
    color-stop(7%, rgba(16, 92, 127, 0.79)),
    color-stop(47%, rgba(40, 160, 220, 0.88)),
    color-stop(80%, rgba(28, 161, 222, 0.95)),
    color-stop(100%, rgba(26, 172, 240, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(16, 92, 127, 0.77) 0%,
    rgba(16, 92, 127, 0.79) 7%,
    rgba(40, 160, 220, 0.88) 47%,
    rgba(28, 161, 222, 0.95) 80%,
    rgba(26, 172, 240, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(16, 92, 127, 0.77) 0%,
    rgba(16, 92, 127, 0.79) 7%,
    rgba(40, 160, 220, 0.88) 47%,
    rgba(28, 161, 222, 0.95) 80%,
    rgba(26, 172, 240, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(16, 92, 127, 0.77) 0%,
    rgba(16, 92, 127, 0.79) 7%,
    rgba(40, 160, 220, 0.88) 47%,
    rgba(28, 161, 222, 0.95) 80%,
    rgba(26, 172, 240, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(16, 92, 127, 0.77) 0%,
    rgba(16, 92, 127, 0.79) 7%,
    rgba(40, 160, 220, 0.88) 47%,
    rgba(28, 161, 222, 0.95) 80%,
    rgba(26, 172, 240, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#105c7f', endColorstr='#1aacf0', GradientType=1 );
`;

const mapStateToProps = state => ({
  isFetching: state.users.isFetching,
  appUser: state.auth.appUser,
});

Login = connect(
  mapStateToProps,
  { shibLogin, fetchAppUser, logout }
)(Login);

export default Login;
